import { render, staticRenderFns } from "./NewRealLandCalculationView.vue?vue&type=template&id=6fb5e8d1&scoped=true&"
import script from "./NewRealLandCalculationView.vue?vue&type=script&lang=js&"
export * from "./NewRealLandCalculationView.vue?vue&type=script&lang=js&"
import style0 from "./NewRealLandCalculationView.vue?vue&type=style&index=0&id=6fb5e8d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb5e8d1",
  null
  
)

export default component.exports